export function canSeeTV(dys, userdate) {
    let returnVal = false;

    if(dys !== null && dys !== undefined && !!userdate){
        let usrdttime = new Date(userdate);
        let currdttime = new Date();
        let diffTime = Math.abs(currdttime - usrdttime);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        if (diffDays >= dys) {
            returnVal = true;
        }
    }   
    return returnVal;
}